export { allowPlainRootJsonMapper as jsonMapper } from '../data/json-mapper.js'
